import { render, staticRenderFns } from "./PermissionsCard.vue?vue&type=template&id=44781c9c&"
import script from "./PermissionsCard.vue?vue&type=script&lang=js&"
export * from "./PermissionsCard.vue?vue&type=script&lang=js&"
import style0 from "./PermissionsCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports